export default __webpack_public_path__ + "scripts/resource/56569d6434420a4c09e7317257357583.svg";